import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { brl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { TrendingDown, Share2, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { compartilharTexto } from "@/lib/whatsapp";

export const RankingInadimplentes = () => {
  const { user } = useAuth();
  const empresa = user?.empresa?.nome || "";
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/collection/ranking").then((r) => setRows(r.data)); }, []);

  const whats = (r) => {
    const msg = `Olá ${r.cliente_nome}! Identificamos ${r.parcelas_atrasadas} parcela(s) em atraso totalizando ${brl(r.valor_atrasado)}. Entre em contato para regularizar${empresa ? ` — ${empresa}` : ""}.`;
    compartilharTexto({ telefone: r.telefone, texto: msg, cliente_id: r.cliente_id, titulo: "Cobrança de inadimplência", evento: "cobranca_inadimplente", categoria: "Cobrança" });
  };

  return (
    <div className="trt-card p-5" data-testid="ranking-inadimplentes">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold flex items-center gap-2"><TrendingDown className="w-5 h-5 text-red-500" /> Ranking de Inadimplentes</h3>
        <Button size="sm" variant="ghost" className="text-xs" onClick={() => navigate("/rota-cobranca")} data-testid="ranking-ver-rota">Ver rota</Button>
      </div>
      {!rows ? <div className="py-6 text-center"><Loader2 className="w-5 h-5 animate-spin gold-text mx-auto" /></div>
        : rows.length === 0 ? <div className="py-6 text-center text-slate-400 text-sm">Nenhum cliente em atraso 🎉</div>
        : <ol className="divide-y">
          {rows.map((r, i) => (
            <li key={r.cliente_id} className="flex items-center gap-3 py-2.5" data-testid={`ranking-row-${r.cliente_id}`}>
              <span className={`w-7 h-7 rounded-full grid place-items-center text-xs font-extrabold ${i === 0 ? "bg-red-600 text-white" : i < 3 ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-600"}`}>{i + 1}</span>
              <button className="flex-1 text-left min-w-0" onClick={() => navigate(`/clientes/${r.cliente_id}`)}>
                <div className="font-semibold text-sm truncate">{r.cliente_nome}</div>
                <div className="text-xs text-slate-500">{r.parcelas_atrasadas} parcela(s) • <span className="text-red-600 font-semibold">{r.dias_atraso} dia(s) de atraso</span></div>
              </button>
              <div className="text-right font-bold text-red-600 mono text-sm">{brl(r.valor_atrasado)}</div>
              {r.telefone && <Button size="sm" variant="ghost" className="text-emerald-600" onClick={() => whats(r)} data-testid={`ranking-whats-${r.cliente_id}`}><Share2 className="w-4 h-4" /></Button>}
            </li>
          ))}
        </ol>}
    </div>
  );
};
